import api from '../services/api';

const cache = new Map();

export function getQuestions(protocolId) {
  const key = Number(protocolId);
  if (cache.has(key)) {
    return cache.get(key);
  }
  
  const promise = api.get(`/questions?protocol_id=${key}&_t=${Date.now()}`)
    .then(res => res.data)
    .catch(err => {
      cache.delete(key);
      throw err;
    });
  cache.set(key, promise);
  return promise;
}

export function clearQuestionsCache() {
  cache.clear();
}
